import type { GenerationJob, JobError } from '@/types/api';

// Only explicit credit phrases count. A bare "부족" / "insufficient" also
// appears in content failures ("선택지 쌍 부족", "…부족하거나 겹칩니다"), which
// must keep the admin-report and retry path instead of a "top up points" prompt.
const CREDIT_SIGNAL_PATTERN = /포인트\s*(?:가\s*)?부족|크레딧\s*(?:이\s*)?부족|insufficient[\s_-]*credit/i;

export function includesCreditSignal(value?: string | null): boolean {
  if (!value) return false;
  return CREDIT_SIGNAL_PATTERN.test(value);
}

export function isInsufficientCreditError(err: Pick<JobError, 'error' | 'error_code'>): boolean {
  if (err?.error_code === 'insufficient_credits') return true;
  return includesCreditSignal(err?.error);
}

export function isInsufficientCreditJob(
  job: Pick<GenerationJob, 'error_code' | 'error_message' | 'errors'>,
): boolean {
  if (job.error_code === 'insufficient_credits') return true;
  if (includesCreditSignal(job.error_message)) return true;
  return job.errors?.some((err) => isInsufficientCreditError(err)) ?? false;
}
